const {getShoppingCartProductName} = require('./utils');

const processIds = ([type, id] = []) => ({
    ...(type && {type}),
    ...(id && {id}),
});

module.exports = {
    decorate: (data = {}) => data,
    processIds,
    getProductName: getShoppingCartProductName,
};
